import { RobotOutlined } from '@ant-design/icons'
import { Empty } from 'antd'
import { ListPageIntro, ListPageShell } from '../../common'

export const AgentsEngineer = () => {
	return (
		<ListPageShell>
			<ListPageIntro
				icon={RobotOutlined}
				title="Agent: Engineer"
				subtitle="Manage Engineer agent settings and prompts."
			/>
			<Empty description="Engineer agent page is coming soon." />
		</ListPageShell>
	)
}
